/**
 * External dependencies
 */
import { reduce, get, omitBy } from 'lodash';

/**
 * Internal
 */
import { createReducer } from 'state/utils';
import * as actions from 'state/action-types';

export default createReducer(
    {},
    {
        [actions.CONNECTIONS_RECEIVE]: (state, action) => {
            return reduce(
                action.payload.connections,
                (memo, connection) => {
                    const { id } = connection;
                    if (memo === state) {
                        memo = { ...memo };
                    }
                    memo[id] = connection;
                    return memo;
                },
                state,
            );
        },
        [actions.DELETE_CONNECTION_SUCCESS]: (state, action) => {
            const connectionId = get(action, ['payload', ['connectionId']]);
            const items = { ...state };
            return omitBy(items, { id: connectionId });
        },
    },
);